<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">楼宇名称</p>
        <el-input v-model="buildingName" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <div class="stateDiv">
        <p class="searchText">所属公司</p>
        <el-select v-model="buildingCompany" placeholder="请选择所属公司" clearable>
          <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName"
            :value="item.companyId"></el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">楼宇地址</p>
        <el-input v-model="buildingAddr" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addAccount">新增楼宇</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table v-loading="loading" :data="tableData" :default-sort="{prop: 'id', order: 'descending'}"
          style="width: 100%" :highlight-current-row="false"
          :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <el-table-column label="序号" type="index" :index="typeIndex" width="100"></el-table-column>
          <template v-for="(item, index) in tableColumns">
            <el-table-column v-if="item.prop === 'certificateImg'" :key="index" :prop="item.prop" :label="item.label"
              :width="item.width">
              <template slot-scope="scope">
                <!--<div v-for="(item, index) in getImg(scope.row.certificateImg)" :key='index'-->
                <!--  style="display: inline-block">-->
                <el-button type="text" v-if="hasImg(scope.row.certificateImg)"
                  @click="downloadCertification(scope.row)">下载查看
                </el-button>
                  <!--<el-popover placement="top-start" title="" trigger="hover" v-if="hasImg(scope.row.certificateImg)">-->
                  <!--  <img :src="item" alt="" style="width: 1.50rem;height: 1.50rem;">-->
                  <!--  <img slot="reference" :src="item" style="width: .3rem;height: .3rem;margin-left: .03rem">-->
                  <!--</el-popover>-->
                <!--</div>-->
              </template>
            </el-table-column>
            <el-table-column v-else :key="index" :prop="item.prop" :label="item.label" :formatter="item.formatter"
              :width="item.width"></el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next, jumper" :total="totalCount" class="paginationBody"></el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeAdd" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" class="formDiv">
          <el-form-item label="楼宇名称" label-width="1.1rem" prop="buildingName" class="formItem">
            <el-input v-model="addForm.buildingName" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="楼宇地址" label-width="1rem" prop="buildingAddr" class="formItem">
            <el-input v-model="addForm.buildingAddr"></el-input>
          </el-form-item>
          <el-form-item label="所属公司" label-width="1.1rem" prop="companyId" class="formItem">
            <el-select v-model="addForm.companyId" placeholder="请选择所属公司" clearable
              @change="changeCompanyId(addForm.companyId)">
              <el-option v-for="item in companyValueList" :key="item.companyId" :label="item.companyName"
                :value="item.companyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产证面积" label-width="1rem" prop="officialArea" class="formItem">
            <el-input v-model="addForm.officialArea" @blur="blurText($event)" style="width:70%"></el-input>平方米
          </el-form-item>
          <el-form-item label="可租面积" label-width="1.1rem" prop="rentableArea" class="formItem">
            <el-input v-model="addForm.rentableArea" @blur="blurText($event)" style="width:70%"></el-input>平方米
          </el-form-item>
          <el-form-item label="产证编号" label-width="1rem" prop="officialNumber" class="formItem">
            <el-input v-model="addForm.officialNumber"></el-input>
          </el-form-item>
          <el-form-item label="招商专员" label-width="1.1rem" prop="userName" class="formItem">
            <el-select v-model="addForm.userName" placeholder="请选择招商专员" clearable filterable>
              <el-option v-for="item in userInfoList" :key="item.userName" :label="item.userName"
                :value="item.userName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属园区" label-width="1rem" prop="userName" class="formItem">
            <el-select v-model="addForm.parkCode" placeholder="请选择所属园区" clearable  @change="handleParkCode">
              <el-option v-for="item in basePackInfoList" :key="item.parkCode" :label="item.parkName"
                :value="item.parkCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物业公司名称" label-width="1.1rem" prop="manageCoName" class="formItem">
            <el-input v-model="addForm.manageCoName" ></el-input>
          </el-form-item>
          <el-form-item label="物业费单价" label-width="1.1rem" prop="manageFeeUnit" class="formItem">
            <el-input v-model="addForm.manageFeeUnit" @blur="blurText($event)" style="width:80%"></el-input>元
          </el-form-item>
          <el-form-item label="楼宇日租金" label-width="1.1rem" prop="minDailyRental" class="formItemDailyRent">
            <el-input class="inputRent" v-model="addForm.minDailyRental" placeholder="最小值"
              @blur="blurText($event)"></el-input>
            <el-input class="inputRent" style="margin-left: .09rem" v-model="addForm.maxDailyRental" placeholder="最大值"
              @blur="blurText($event)"></el-input>元/平米/日
          </el-form-item>
          <el-form-item label="产证信息" label-width="1rem" prop="certificate" class="formItemImage" >
            <div style="display:flex">
              <el-button type="primary" v-if="addForm.certificateImg"
                @click="downloadCertification(addForm)" style="height:45px;margin-right: 30px">下载查看
              </el-button>
              <el-upload class="upload-demo" ref="uploadFile" action="" :http-request="httpRequest"
                :file-list="fileListPic" show-file-list accept=".pdf" :before-upload="beforeAvatarUpload" :limit="3">
                <el-button class="searchBtn" style="width: 1.5rem"><i class="el-icon-upload2"></i>上传文件</el-button>
                <div slot="tip" class="el-upload__tip">限pdf文件(后缀名为.pdf)</div>
              </el-upload>
            </div>
          </el-form-item>
          <!--<el-form-item label="产证信息" label-width="1rem" prop="certificate" class="formItemImage" v-if="edit === true">-->
            <!--<el-button type="text" v-if="editCertificateImg"-->
            <!--  @click="downloadCertification({ buildingName: addForm['buildingName'], certificateImg: [editCertificateImg] })">下载查看-->
            <!--</el-button>-->
            <!--<el-upload class="upload-demo" ref="uploadFile" action="" :http-request="httpRequest"-->
            <!--  :file-list="fileListPic" show-file-list accept=".pdf" :before-upload="beforeAvatarUpload" :limit="3">-->
            <!--  <el-button class="searchBtn" style="width: 1.5rem"><i class="el-icon-upload2"></i>上传文件</el-button>-->
            <!--  <div slot="tip" class="el-upload__tip">限pdf文件(后缀名为.pdf)</div>-->
            <!--</el-upload>-->
          <!--</el-form-item>-->
          <el-form-item label="备注" label-width="1rem" class="formItemRemark">
            <el-input type="textarea" v-model="addForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { Message } from 'element-ui'
import { uploadFile, fileDownload } from '@/api/user'
import { addBuilding, uploadPic, queryBuilding, deleteBuilding, updateBuilding, queryIdBuild, baseParkInfo, listCanRelTel } from '@/api/basicInfo'
import { listCompanySalesPersons } from '@/api/searchList'

export default {
  name: 'building',
  data () {
    return {
      loading: false,
      roleValue: '',
      buildingCompanyList: [],
      companyValueList: [],
      basePackInfoList: [],
      userInfoList: [],
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      // companyName: '',
      companyAddress: '',
      buildingName: '',
      buildingCompany: '',
      buildingAddr: '',
      edit: false,
      editCertificateImg: '',
      // 上传产证信息照片
      fileListPic: [],
      fileUrls: [],
      fileUrlsString: '',
      newImgList: [],
      itemList: [], // 编辑弹框 展示图片时的参数
      fileUrlNew: '', // 编辑 更新时的图片参数
      hideUpload: false,
      addForm: {
        buildingName: '',
        buildingAddr: '',
        companyId: '',
        officialArea: '',
        rentableArea: '',
        officialNumber: '',
        manageFeeUnit: '',
        manageCoName: '',
        userName: '',
        remark: '',
        minDailyRental: '',
        maxDailyRental: '',
        parkCode: '',
      },
      rules: {
        buildingName: [{ required: true, message: '请填写', trigger: 'blur' }],
        buildingAddr: [{ required: true, message: '请填写', trigger: 'blur' }],
        companyId: [{ required: true, message: '请填写', trigger: 'blur' }],
        officialArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        rentableArea: [{ required: true, message: '请填写', trigger: 'blur' }],
        officialNumber: [{ required: true, message: '请填写', trigger: 'blur' }],
        manageFeeUnit: [{ required: true, message: '请填写', trigger: 'blur' }],
        manageCoName: [{ required: true, message: '请填写', trigger: 'blur' }],
        userName: [{ required: true, message: '请填写', trigger: 'blur' }],
        minDailyRental: [{ required: true, message: '请填写', trigger: 'blur' }]
        // fileListPic: [{ required: true, message: '请填写', trigger: 'blur' }],
        // remark: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'buildingName',
          label: '楼宇名称'
        },
        {
          prop: 'buildingAddr',
          label: '楼宇地址'
        },
        {
          prop: 'companyName',
          label: '所属公司'
        },
        {
          prop: 'officialArea',
          label: '产证面积'
        },
        {
          prop: 'rentableArea',
          label: '可租面积'
        },
        {
          prop: 'officialNumber',
          label: '产证编号'
        },
        {
          prop: 'userName',
          label: '招商专员'
        },
        {
          prop: 'manageFeeUnit',
          label: '物业费单价'
        },
        {
          prop: 'manageCoName',
          label: '物业公司名称'
        },
        {
          prop: 'certificateImg',
          label: '产证信息'
        },
        {
          prop: 'remark',
          label: '备注'
        }
      ]
    }
  },
  watch: {
    // 选择所属公司后，对应招商员
    // 'addForm.companyId': {
    //   handler (v) {
    //     if (v) {
    //       this.userInfoList = this.companyValueList.filter(i => i.companyId === v)[0].userInfoList
    //     } else {
    //       this.userInfoList = []
    //       this.addForm.userName = ''
    //     }
    //   },
    // deep: true,
    // immediate: false
    // }
  },
  mounted () {
    this.getData()
    this.getCompanyList()
    this.getlistCanRelTel()
    this.baseParkList()
  },
  methods: {
    handleParkCode(code) {
      let parkItem = this.basePackInfoList.find(v => v.parkCode === code)
      this.addForm.manageCoName = parkItem.managementCompany
    },
    async baseParkList() {
      const { result } = await baseParkInfo('query', {
        pageNum: 1,
        pageSize: 999
      })
      this.basePackInfoList = result.records
    },
    // 下载产证信息
    async downloadCertification (row) {
      let res = await fileDownload((row.certificateImg instanceof Array && row.certificateImg[0]) || row.certificateImg)
      let blob = new Blob([res.data], { type: res.data.type })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = row.buildingName + '产证信息.pdf'
      link.click()
    },
    // 上传产证
    async httpRequest (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      const { code, result, message } = await uploadFile(fd)
      if (code === 0) {
        this.fileUrlsString = result // 后端接收的参数类型是string，所以要转换成string
      } else {
        this.$message.error(message)
      }
      // todo fileList置空
      //   // this.fileList = []
    },
    blurText (e) {
      let boolean = new RegExp('^(-?\\d+)(\\.\\d+)?$').test(e.target.value)
      if (!boolean) {
        Message({
          message: '请输入数字',
          type: 'warning'
        })
        e.target.value = ''
      }
    },
    // 处理表格序号，序号递增
    typeIndex (index) {
      let vm = this // 处理分页数据的 index
      return (vm.currentPage - 1) * vm.pageSize + index + 1
    },
    async getlistCanRelTel() {
            let res = await listCanRelTel({ 
                chineseName: '',
                pageSize: 999,
                pageNum: 1
            })
            this.userInfoList = res.result
        },
    // 修改“所属公司”下拉框
    changeCompanyId () {
      // this.addForm.userName = ''
    },
    // 所属公司-招商员 级联下拉框
    async getCompanyList () {
      let res = await listCompanySalesPersons()
      if (res.code === 0) {
        this.companyValueList = res.result
      }
    },
    // 编辑弹框 是否有后端传的图片信息，没有的话不显示图片框
    thisItemList (data) {
      if (data !== '') {
        return true
      } else {
        return false
      }
    },
    // 展示图片
    getImg (data) {
      this.imgList = []
      if (data !== []) {
        for (let i in data) {
          this.imgList.push(process.env.VUE_APP_BASE_API + '/minio/getImage?fileName=' + data[i])
        }
        return this.imgList
      }
    },
    // 查询时，返回的图片信息不为空
    hasImg (row) {
      if (row[0] !== '') {
        return true
      } else {
        return false
      }
    },
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    // 查询
    async queryList () {
      let res = await queryBuilding({
        companyId: this.buildingCompany,
        buildingName: this.buildingName,
        buildingAddr: this.buildingAddr,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = []
        res.result.records.forEach(item => {
          this.tableData.push({
            buildingName: item.buildingName,
            buildingAddr: item.buildingAddr,
            companyName: item.companyName,
            officialArea: item.officialArea,
            rentableArea: item.rentableArea,
            officialNumber: item.officialNumber,
            userName: item.userName,
            manageFeeUnit: item.manageFeeUnit,
            manageCoName: item.manageCoName,
            remark: item.remark,
            id: item.id,
            certificateImg: item.certificateImg.split(',')
          })
        })
        this.totalCount = res.result.total
      }
    },
    addAccount () {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增楼宇'
    },
    // 编辑楼宇 信息展示
    async viewOrHandle (row) {
      this.edit = true
      this.dialogFormVisible = true
      this.eventControl = '编辑楼宇'
      let res = await queryIdBuild({
        id: row.id
      })
      if (res.code === 0) {
        if (res.result.companyName === null) {
          this.addForm = Object.assign({}, res.result, { companyId: null })
        } else {
          this.addForm = Object.assign({}, res.result, { companyId: res.result.companyId })
        }
        // this.fileIdUrl = res.result.certificateImg
        this.itemList = res.result.certificateImg.split(',')
        this.editCertificateImg = res.result.certificateImg
        this.id = row.id
        if (this.itemList.length < 3) {
          this.hideUpload = false
        }
      }
    },
    closeAdd () {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.fileListPic = []
      this.fileUrlsString = ''
      this.fileUrls = []
      this.addForm = {
        buildingName: '',
        buildingAddr: '',
        companyId: '',
        officialArea: '',
        rentableArea: '',
        officialNumber: '',
        manageFeeUnit: '',
        manageCoName: '',
        userName: '',
        remark: ''
      }
    },
    addEventForm () {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            // if (this.fileUrlsString !== '') {
            //   this.fileUrlNew = this.itemList.join(',') + ',' + this.fileUrlsString
            // } else {
            //   this.fileUrlNew = this.itemList.join(',')
            // }
            // if (this.itemList.join(',') === '' && this.fileUrlsString !== '') {
            //   this.fileUrlNew = this.fileUrlsString
            // }
            // if (this.itemList.join(',') === '' && this.fileUrlsString === '') {
            //   this.fileUrlNew = ''
            // }
            // if (this.fileUrlNew.split(',').length > 3) {
            //   Message.warning({ message: '最多上传三张图片' })
            //   return
            // }
            let res = await updateBuilding({
              buildingName: this.addForm.buildingName,
              buildingAddr: this.addForm.buildingAddr,
              companyId: this.addForm.companyId,
              officialArea: this.addForm.officialArea,
              rentableArea: this.addForm.rentableArea,
              officialNumber: this.addForm.officialNumber,
              manageFeeUnit: this.addForm.manageFeeUnit,
              manageCoName: this.addForm.manageCoName,
              userName: this.addForm.userName,
              remark: this.addForm.remark,
              certificateImg: this.fileUrlsString || this.addForm.certificateImg,
              id: this.id,
              minDailyRental: this.addForm.minDailyRental,
              maxDailyRental: this.addForm.maxDailyRental,
              parkCode: this.addForm.parkCode
            })
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.dialogFormVisible = false
              this.$refs['addForm'].resetFields()
              this.addForm = {
                buildingName: '',
                buildingAddr: '',
                companyId: '',
                officialArea: '',
                rentableArea: '',
                officialNumber: '',
                manageFeeUnit: '',
                manageCoName: '',
                userName: '',
                parkCode: '',
                remark: ''
              }
              this.fileListPic = []
              this.fileUrlsString = ''
              this.fileUrls = []
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await addBuilding({
              buildingName: this.addForm.buildingName,
              buildingAddr: this.addForm.buildingAddr,
              companyId: this.addForm.companyId,
              officialArea: this.addForm.officialArea,
              rentableArea: this.addForm.rentableArea,
              officialNumber: this.addForm.officialNumber,
              manageFeeUnit: this.addForm.manageFeeUnit,
              manageCoName: this.addForm.manageCoName,
              userName: this.addForm.userName,
              remark: this.addForm.remark,
              certificateImg: this.fileUrlsString,
              minDailyRental: this.addForm.minDailyRental,
              maxDailyRental: this.addForm.maxDailyRental,
              parkCode: this.addForm.parkCode
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                buildingName: '',
                buildingAddr: '',
                companyId: '',
                officialArea: '',
                rentableArea: '',
                officialNumber: '',
                manageFeeUnit: '',
                manageCoName: '',
                userName: '',
                parkCode: '',
                remark: ''
              }
              this.fileListPic = []
              this.fileUrlsString = ''
              this.fileUrls = []
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除分组
    deleteFun (row) {
      this.$confirm('此操作将删除该楼宇信息以及房屋关联信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await deleteBuilding(params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    },
    // 上传产证信息照片
    async httpRequestPic (param) {
      let file = param.file
      let fd = new FormData()
      fd.append('file', file)
      let res = await uploadPic(fd)
      if (res.code === 0) {
        this.fileUrls.push(res.result)
        this.fileUrlsString = this.fileUrls.join(',') // 后端接收的参数类型是string，所以要转换成string
      } else {
        this.$message.error(res.message)
      }
    },
    beforeAvatarUpload (file) {
      // 格式过滤
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'

      if (!extension) {
        this.$message.error('上传的文件只能是pdf格式')
      }
      return extension
    },
    handleAddChange (file, fileList) {
      if (fileList.length >= 3) {
        this.hideUpload = true
      }
    },
    handleRemovePic (file, fileList) {
      this.fileUrls.splice(this.fileUrls.findIndex(i => i === file.url), 1)
      this.hideUpload = fileList.length >= 3
      this.fileUrlsString = this.fileUrls.join(',')
    },
    // 删除图片
    deleteImg (item) {
      this.$confirm('是否删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let deleteIndex1 = this.itemList.findIndex(i => i === item.split('=')[1])
        this.itemList.splice(deleteIndex1, 1)
        // let deleteIndex2 = this.fileUrls.findIndex(i => i === item.split('=')[1])
        // this.fileUrls.splice(deleteIndex2, 1)
        // let fd = new FormData()
        // fd.append('fileName', item.split('=')[1])
        // let res = await deletefile(fd)
        // if (res.code === 0) {
        //   Message.success('删除成功！')
        //   let deleteIndex = this.itemList.findIndex(i => i === item)
        //   this.itemList.splice(deleteIndex, 1)
        //   // this.fileIdUrl = this.fileIdUrl.concat(this.itemList.join(','))
        // }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}
.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/
  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }
  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }
  .inputDiv {
    width: 2.2rem;
    float: left;
  }
  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}
.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;
  .searchList {
  }
  .paginationBody {
    margin-top: .1rem;
  }
}
.formDiv {
  .formItem {
    display: inline-block;
    width: 3.2rem;
    float: left;
  }
  .formItemDailyRent {
    display: inline-block;
    float: left;
    width: 5.2rem;
    .inputRent {
      width: 1.03rem;
    }
  }
  .formItemImage {
    display: inline-block;
    /*float: left;*/
  }
  .formItemRemark {
    display: block;
    width: 3.2rem;
  }
}
/deep/ .hide .el-upload--picture-card {
  display: none;
}
/deep/ .el-dialog {
  width: 40% !important;
}
</style>
